import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "error_tips" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "error_tips__icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "error_tips__content" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _hoisted_1
    ]),
    _: 1
  }, 8, ["locale"]))
}